// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ConfirmationModal-backdrop___cb5afe93365b6193e29{align-items:flex-start}@media(min-width: 768px){.ConfirmationModal-backdrop___cb5afe93365b6193e29{align-items:center}}.ConfirmationModal-modal__d22f340fe91280e760d6{padding:8px 16px;width:calc(100% - 16px);border-radius:2px;margin:8px}@media(min-width: 768px){.ConfirmationModal-modal__d22f340fe91280e760d6{padding:16px 32px 24px;width:60vw;margin:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backdrop": "ConfirmationModal-backdrop___cb5afe93365b6193e29",
	"modal": "ConfirmationModal-modal__d22f340fe91280e760d6"
};
export default ___CSS_LOADER_EXPORT___;
